import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';


export function NestedListBackoffice({labelList, iconList, listItems}) {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton onClick={handleClick} >
        <ListItemIcon>
          {iconList}
        </ListItemIcon>
        <ListItemText primary={labelList} className='list-item-root'/>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
            {
                listItems.map((list, index) => (
                    <a href={list?.href} key={index + 2}>
                    <ListItemButton  sx={{ pl: 4 }} key={index}>
                      <ListItemIcon key={index + 1}>
                        {list?.icon}
                      </ListItemIcon>
                      <ListItemText primary={list?.name} key={index + 3} className='list-item-child'/>
                    </ListItemButton>
                    </a>
                 ))
            }
        </List>
      </Collapse>

    </List>
  );
}
